/** Row arrangement of `dd-label-list`: label above the value, or label left of it. */
export const LabelListLayoutEnum = <const>{
  Stacked: 'stacked',
  Inline: 'inline',
};
export type LabelListLayout = (typeof LabelListLayoutEnum)[keyof typeof LabelListLayoutEnum];
